import React, { memo, useCallback, useEffect, useState } from 'react'
import WithLabel from '../WithLabel/WithLabel'
import { Select } from 'antd'
import styles from './CrmSelect.module.scss'
import cn from 'classnames'
import { ICrmLight } from '@interfaces/crm.interface'

const { Option } = Select

interface Props {
  onChange?: (value: string[]) => void
  title?: string
  initialValue?: string[]
  className?: any
  allowClear?: boolean
  disabled?: boolean
  setIsAllCrms?: (val: boolean) => void
  crmsLight: ICrmLight[]
  isLoading: boolean
}

const CrmSelect: React.FC<Props> = ({
  onChange,
  title,
  initialValue,
  className,
  crmsLight,
  isLoading,
  setIsAllCrms,
  allowClear = false,
  disabled = false,
}) => {
  const [selectedCrms, setSelectedCrms] = useState<string[]>([])

  const handleSelect = useCallback(
    (value: string[]) => {
      if (!value.length && !allowClear) {
        setSelectedCrms(['all'])
        return
      }
      if (value.includes('all') && !selectedCrms?.includes('all')) {
        setSelectedCrms(['all'])
        return
      }
      if (!value.includes('all') && value.length === crmsLight.length) {
        setSelectedCrms(['all'])
        return
      }
      setSelectedCrms(value.filter((val) => val !== 'all'))
    },
    [crmsLight, selectedCrms],
  )

  useEffect(() => {
    if (!isLoading && crmsLight.length && initialValue && initialValue.length) {
      if (crmsLight.length === initialValue.length && initialValue[0] !== 'all') {
        setSelectedCrms(['all'])
      } else {
        setSelectedCrms(initialValue)
      }
    }
  }, [isLoading, crmsLight])

  useEffect(() => {
    if (onChange) {
      if (selectedCrms?.includes('all')) {
        setIsAllCrms && setIsAllCrms(true)
        onChange(crmsLight.map((el) => el.id))
      } else {
        setIsAllCrms && setIsAllCrms(false)
        onChange(selectedCrms)
      }
    }
  }, [selectedCrms, setIsAllCrms])

  const renderSelect = () => {
    return (
      <Select
        disabled={disabled}
        allowClear={allowClear}
        className={cn(styles.userSelect, className)}
        value={isLoading || !crmsLight.length ? [] : selectedCrms}
        loading={isLoading}
        mode='multiple'
        placeholder='Выберите CRM'
        onChange={(e) => handleSelect(e)}
        filterOption={(input, option) =>
          option?.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        getPopupContainer={() => document.getElementById('App') || document.body}
      >
        <>
          {!isLoading && crmsLight.length && (
            <>
              <Option onSelect={() => handleSelect(['all'])} key='all'>
                Все CRM
              </Option>
              {crmsLight.map((el) => (
                <Option value={el.id} key={el.id}>
                  {el.name}
                </Option>
              ))}
            </>
          )}
        </>
      </Select>
    )
  }

  return (
    <>{title ? <WithLabel label={title}>{renderSelect()}</WithLabel> : <>{renderSelect()}</>}</>
  )
}

export default memo(CrmSelect)
